module.exports = __webpack_public_path__ + "img/img_ai_test_stock_bg@2x.63973380.png";